export default __webpack_public_path__ + "static/media/indian-flag.bc246f2a.svg";